import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from "react-redux"

import ArtistLoginForm from '../components/ArtistLoginForm';
import Aux from './AuxContainer'
import AMLogo from '../assets/images/audition-magic-favicon.png';
import studio from '../assets/images/studio.jpg';
import agent from '../agent'
import { store, history } from '../store/configureStore'
import ssl from '../assets/images/SSL.png'
import newAMLogo from '../assets/images/AMBanner2.png'

const style = {
	backgroundImage: `url(${studio})`,
	backgroundSize: `cover`,
	backgroundPosition: `center`
}

const ComingSoon = () => {
	const adjust = {
		height: '9rem'
	}
	const url = 'https://casting.auditionmagic.com/'
	return (<div id="coming-soon">
		<h2 className="modal-title">New Login & Features Coming Soon</h2>
		<p className="modal-description">In the meantime please click the button below to login at a different page.</p>
		<div style={adjust}></div>
		<a href={url} target="_blank" className="button primary">GO TO LOGIN</a></div>
		)
}
 
class NewLandingContainer extends Component {
	state = {
	    artistCl: "cell medium-6 small-6 tabs-title is-active",
	    agencyCl: "cell medium-6 small-6 tabs-title",
	    artistClPanel: "tabs-panel is-active",
	    agencyClPanel: "tabs-panel",
	    artistAria: true,
	    agencyAria: false,
	    flag: 'artist'
	  }

	  onSubmit = values => {
	  	const { username, password } = values
	  	const projectId = new URLSearchParams(this.props.location.search).get('project');
	  	const publicRegistration = new URLSearchParams(this.props.location.search).get('token');
	  	
	  	if (username && password) {
	  		if (projectId) {
	  			return this.props.partialLogin(username, password)
	  		} else if (publicRegistration) {
	  			return this.props.publicLogin(username, password)
	  		} else {
	  			return this.props.artistLogin(username, password);		
	  		}
	  	}
	  }

	  onSubmitAgency = values => {
	  	const { username, password } = values

	  	agent.Artist.login(username, password).then((result) => {
	  		console.log('onSubmitAgency', result)
	  		this.props.history.push({
	  			pathname: '/agencydashboard',
	  			search: `?token=${result.agency.agency_access_token}`,
	  			state: {
	  				agency: result
	  			}
	  		})
	  	})
	  }

	 componentWillMount() {
	 	 const isCheckin = window.location.hostname == "checkin.auditionmagic.com"
     if (isCheckin) {
       window.location = "//app.auditionmagic.com/client";
     }
	 }
	  
	 componentDidMount() {
	 	console.log('landing-componentDidMount', this.props, this.props.match.path === '/agent', this.props.match.path === '/talent')
	 	if (this.props.match.path === '/agent') {
	 		this.setState({
		        artistCl: "cell medium-6 small-6 tabs-title",
		        agencyCl: "cell medium-6 small-6 tabs-title is-active",
		        artistClPanel: "tabs-panel tabs-add",
		        agencyClPanel: "tabs-panel tabs-add is-active",
		        artistAria: false,
		        agencyAria: true,
		        flag: 'agency'
		      })
		  }
		if (this.props.match.path === '/talent') {
			this.setState({
		        artistCl: "cell medium-6 small-6 tabs-title is-active",
		        agencyCl: "cell medium-6 small-6 tabs-title",
		        artistClPanel: "tabs-panel tabs-add is-active",
		        agencyClPanel: "tabs-panel tabs-add",
		        artistAria: true,
		        agencyAria: false,
		        flag: 'artist'
		      })
		}
	 }

	getInitialValues () {
	    
	  }

	 toggleLogin = (flag) => {
	    if (flag === 'artist') {
	      this.setState({
	        artistCl: "cell medium-6 small-6 tabs-title is-active",
	        agencyCl: "cell medium-6 small-6 tabs-title",
	        artistClPanel: "tabs-panel tabs-add is-active",
	        agencyClPanel: "tabs-panel tabs-add",
	        artistAria: true,
	        agencyAria: false,
	        flag: flag
	      })
	      history.push('/talent')
	    }
	    if (flag === 'agency') {
	      this.setState({
	        artistCl: "cell medium-6 small-6 tabs-title",
	        agencyCl: "cell medium-6 small-6 tabs-title is-active",
	        artistClPanel: "tabs-panel tabs-add",
	        agencyClPanel: "tabs-panel tabs-add is-active",
	        artistAria: false,
	        agencyAria: true,
	        flag: flag
	      })
	 	  history.push('/agent')
	 	}
	  }

	render() {
		const { handleSubmit, previousPage, nextPage, pristine, submitting, media, publicArtist, errors, location, project, company } = this. props
		const { artistCl, agencyCl, artistAria, agencyAria, artistClPanel, agencyClPanel } = this.state
		const newStyle = {
			paddingTop: '1rem'
		}
		const divAdjust = {
			paddingBottom: '6rem'
		}
		const pAdjust = {
			paddingLeft: '2rem',
			paddingRight: '2rem'
		}
		return (
			<Aux>
				<div id="landing-page" style={style}>
				

				  <div className="small-12 grid-x align-center align-middle text-center cell">
				  	<div style={divAdjust} className="cell">
			      		<a href="https://www.auditionmagic.com/" target="_blank"><img className="float-left" width="400px" src={newAMLogo} /></a>
			      	</div>
				    <div className="small-12 cell text-center custom2">
				      <div id="login-landing" className="grid-x medium-12 align-center">
				      	{
				      		/*<div className="cell medium-12">
				      		<p><img className="logo" src={AMLogo} alt="" /></p>
						    <p className="top-title">Audition Magic</p>
							<h6 className="subheader">Get Started</h6>
				      		</div>*/
				      	}
				      	<div className="cell medium-3">
					      	<ul className="grid-x tabs" data-tabs id="login-tabs">
			                  <li className={artistCl}><a aria-selected={artistAria} onClick={e => this.toggleLogin("artist")}>TALENT</a></li>
			                  <li className={agencyCl}><a aria-selected={agencyAria} onClick={e => this.toggleLogin("agency")}>AGENTS</a></li>
			                </ul>
			                <div className="tabs-content" data-tabs-content="login-tabs">
			                  {
			                  	this.state.flag === 'artist' &&
			                  	(<div>
				                    <h2 className="modal-title">Login</h2>
				                    <p style={pAdjust} className="modal-description">Please enter your details below to proceed</p>
			                  	</div>)
			              	  }
			                  <div className={artistClPanel} id="artist_panel">
			                    <ArtistLoginForm 
			                      isCheckingArtist={this.state.isCheckingArtist}
			                      onSubmit={this.onSubmit}
			                      initialValues={this.getInitialValues()}
			                      errors={errors} />
			                  </div>
			                  {
			                  	this.state.flag !== 'artist' &&
			                  	(<div>
				                    <h2 className="modal-title">Login</h2>
				                    <p style={pAdjust} className="modal-description">Please enter your details below to proceed</p>
			                  	</div>)
			              	  }
			                  <div className={agencyClPanel} id="agency_panel">
			                    <ArtistLoginForm 
			                      isCheckingArtist={this.state.isCheckingArtist}
			                      onSubmit={this.onSubmitAgency}
			                      initialValues={this.getInitialValues()}
			                      errors={errors} />
			                  </div>
			                </div>
		                </div>
		                <div className="cell">
		                	<img style={newStyle} src={ssl} width="175px" />
		                </div>
				      </div>
				      {
					      /*<div className="chooser">
					        <Link to="/client/login" className="button big white">I AM THE CLIENT</Link>
					        <Link to="/artist/login" className="button big dark-gray">I AM THE ARTIST</Link>				      
					      </div>*/
				      }
				    </div>
				  </div>

				</div>
			</Aux>
		)
	}
}

const mapStateToProps = state => ({
	...state.auth,
	...state.common
})

const mapDispatchToProps = dispatch => ({
	artistLogin: (username, password) => 
		dispatch({
			type: 'ARTIST_LOGIN', 
			payload: agent.Artist.login(username, password)
		}),
	partialLogin: (username, password) =>
		dispatch({ 
			type: 'PARTIAL_ARTIST_LOGIN', 
			payload: agent.Artist.login(username, password) }),
	publicLogin: (username, password) =>
		dispatch({ 
			type: 'PUBLIC_ARTIST_LOGIN', 
			payload: agent.Artist.login(username, password) }),
	agencyLogin: (username, password) =>
		dispatch({
			type: 'AGENCY_LOGIN',
			payload: agent.Artist.login(username, password) }),
	onUnload: () => 
		dispatch({ type: 'ARTIST_PAGE_UNLOADED' })
})

export default connect(mapStateToProps, mapDispatchToProps)(NewLandingContainer)


// WEBPACK FOOTER //
// ./src/containers/NewLandingContainer.js